import { render, staticRenderFns } from "./buyerWriteOff.vue?vue&type=template&id=15cf1da6&scoped=true&"
import script from "./buyerWriteOff.vue?vue&type=script&lang=js&"
export * from "./buyerWriteOff.vue?vue&type=script&lang=js&"
import style0 from "./buyerWriteOff.vue?vue&type=style&index=0&id=15cf1da6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15cf1da6",
  null
  
)

export default component.exports